<a routerLink="/ussdSessions/{{ussdSessionId}}" matTooltip="Jump to {{ussdSessionId}}">{{ussdSessionId}}</a>
